export enum SettingsTab {
  Main = 'Main',
  Display = 'Display',
  Settings = 'Settings',
  Layout = 'Layout',
  Design = 'Design',
}
